module.exports = __webpack_public_path__ + "img/symphony_533_sahara.3293ff51.jpg";